module.exports = __webpack_public_path__ + "img/13_25.d7cbece1.png";